import React from 'react';
import styled from 'styled-components';

const NotFound: React.FC = () => {
    return (
        <NotFoundContainer>
            <h2>404 - ページが見つかりません</h2>
        </NotFoundContainer>
    );
};

const NotFoundContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    font-size: 2rem;
`;

export default NotFound;
